import Notification from './notification';

function isValidToast(feedback) {
  const {method, type, message, toastDuration, toastDismissable} = feedback;
  const isToast = Boolean(method && method === 'toast');
  const hasMessage = Boolean(message && message.basePropertyValue);

  return Boolean(type && hasMessage && isToast);
}

function hasToast(data) {
  return Boolean(data && data.meta && data.meta.feedback) && isValidToast(data.meta.feedback);
}

function getToast(feedback) {
  const {method, type, toastDismissable, toastDuration} = feedback;
  const message = feedback.message.basePropertyValue;

  return {type, message, toastDismissable, toastDuration};
}

function axiosToast(data) {
  if (hasToast(data)) {
    const {type, message, toastDismissable, toastDuration} = getToast(data.meta.feedback);
    const duration = toastDuration && toastDuration >= 0 ? toastDuration : 5000;
    const showClose = duration === 0 ? true : Boolean(toastDismissable);

    window.vm.$notify({
      type,
      message,
      showClose: showClose,
      duration: duration,
      link: data.meta.feedback.link,
    });
  }
}

const axiosConfig = {
  baseURL: window.ACC.config.encodedContextPath,
};

export {axiosConfig, axiosToast, getToast};
